import axios from 'axios'
import api from './api'
import Vue from 'vue'
import router from '../router'
import { Toast } from 'vant'
import qs from 'qs'

let Base64 = require('js-base64').Base64

Vue.use(Toast)

const instance = axios.create({
    baseURL: 'https://api.allure.town/api',
    timeout: 5000,
})

function redirectToLogin() {
    localStorage.removeItem('token')
    if (router.currentRoute.path !== '/Login') {
        router.replace({ path: '/Login' })
    }
}

instance.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data'
    } else if (config.method === 'post') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
        config.data = qs.stringify(config.data)
    }

    if (localStorage.getItem('token')) {
        config.headers['token'] = Base64.encode(localStorage.getItem('token'))
    }

    config.headers['lang'] = localStorage.getItem('lang') || 'yn_yu'

    return config
}, err => {
    console.error('request failed', err)
})

instance.interceptors.response.use(res => {
    const isAuthError = res && res.data && (
        res.data.code === 401
        || res.data.msg === 'Authentication error'
        || res.data.msg === ''
    )

    if (isAuthError) {
        redirectToLogin()
    }

    return res
}, err => {
    if (err && err.response && err.response.status === 401) {
        redirectToLogin()
    }

    return Promise.reject(err)
})

async function http(option = {}) {
    let result = null

    if (option.method === 'get' || option.method === 'delete') {
        await instance[option.method](
            api[option.url],
            { params: option.data }
        ).then(res => {
            result = res.data
        }).catch(err => {
            result = err
        })
    } else if (option.method === 'post' || option.method === 'put') {
        await instance[option.method](
            api[option.url],
            option.data
        ).then(res => {
            result = res.data
        }).catch(err => {
            result = err
        })
    }

    return result
}

export default http
